import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, ArrowRight, MapPin, Phone, Mail } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#1e3a5f] text-white pt-16 pb-8 border-t-8 border-[#d4a017]" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-16">
          {/* Brand */}
          <div data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/7UkpvhWwAjtzJHkmXMwSvP/MANDM-PIPE-SERVICES-LOGO.png" alt="M&M Pipe Services" className="h-20 w-auto mb-6 bg-white p-2 rounded" data-id="element-18" />
            <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-19">
              East Tennessee's premier commercial sewer and drain cleaning
              service. 50 years of experience delivering quality results.
            </p>
            <div className="flex space-x-4 mb-8" data-id="element-20">
              <a href="#" className="bg-[#d4a017] p-2 rounded-full text-[#1e3a5f] hover:bg-white transition-colors" data-id="element-21">
                <Facebook className="w-5 h-5" data-id="element-22" />
              </a>
              <a href="#" className="bg-[#d4a017] p-2 rounded-full text-[#1e3a5f] hover:bg-white transition-colors" data-id="element-23">
                <Linkedin className="w-5 h-5" data-id="element-24" />
              </a>
            </div>

            {/* Certifications */}
            <div data-id="element-25">
              <p className="text-sm font-bold text-[#d4a017] uppercase tracking-wider mb-3" data-id="element-26">
                NASSCO Certified
              </p>
              <div className="flex space-x-3" data-id="element-27">
                <img src="https://cdn.magicpatterns.com/uploads/e3gmq2BP1jL2eiKDfzZ1An/Badge-PACP.png" alt="PACP Certified" className="h-12 w-auto bg-white rounded-full p-0.5 opacity-90 hover:opacity-100 transition-opacity" data-id="element-28" />
                <img src="https://cdn.magicpatterns.com/uploads/hNCCy2K15mUz4yJymjbgMJ/LACP-CERTIFIED.png" alt="LACP Certified" className="h-12 w-auto bg-white rounded-full p-0.5 opacity-90 hover:opacity-100 transition-opacity" data-id="element-29" />
                <img src="https://cdn.magicpatterns.com/uploads/mu2YoBgtQ6GHD7rj93TwzT/MACP-CERTIFIED2.png" alt="MACP Certified" className="h-12 w-auto bg-white rounded-full p-0.5 opacity-90 hover:opacity-100 transition-opacity" data-id="element-30" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-31">
            <h3 className="text-xl font-bold mb-6 text-[#d4a017] uppercase tracking-wider" data-id="element-32">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-33">
              {[{
              name: 'Home',
              path: '/'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Projects & Vendors',
              path: '/projects-vendors'
            }, {
              name: 'Contact Us',
              path: '/contact'
            }].map(item => <li key={item.name} data-id="element-34">
                  <Link to={item.path} className="text-gray-300 hover:text-[#d4a017] transition-colors flex items-center" data-id="element-35">
                    <ArrowRight className="w-3 h-3 mr-2" data-id="element-36" /> {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-37">
            <h3 className="text-xl font-bold mb-6 text-[#d4a017] uppercase tracking-wider" data-id="element-38">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-39">
              <li className="text-gray-300" data-id="element-40">Sewer System Maintenance</li>
              <li className="text-gray-300" data-id="element-41">Digital CCTV Inspection</li>
              <li className="text-gray-300" data-id="element-42">Hydro Excavation</li>
              <li className="text-gray-300" data-id="element-43">Manhole Cleaning</li>
              <li className="text-gray-300" data-id="element-44">24/7 Emergency Service</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-45">
            <h3 className="text-xl font-bold mb-6 text-[#d4a017] uppercase tracking-wider" data-id="element-46">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-47">
              <li className="flex items-start" data-id="element-48">
                <MapPin className="w-5 h-5 mr-3 text-[#d4a017] flex-shrink-0 mt-1" data-id="element-49" />
                <span className="text-gray-300" data-id="element-50">
                  Clinton, TN
                  <br data-id="element-51" />
                  Serving East Tennessee
                </span>
              </li>
              <li className="flex items-center" data-id="element-52">
                <Phone className="w-5 h-5 mr-3 text-[#d4a017] flex-shrink-0" data-id="element-53" />
                <a href="tel:8653130028" className="text-gray-300 hover:text-white" data-id="element-54">
                  865-313-0028
                </a>
              </li>
              <li className="flex items-center" data-id="element-55">
                <Mail className="w-5 h-5 mr-3 text-[#d4a017] flex-shrink-0" data-id="element-56" />
                <a href="mailto:info@mmpipeservices.com" className="text-gray-300 hover:text-white break-all" data-id="element-57">
                  info@mmpipeservices.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center text-gray-400 text-sm" data-id="element-58">
          <p data-id="element-59">
            &copy; {new Date().getFullYear()} M&M Pipe Services LLC. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};